module.exports = __webpack_public_path__ + "1pO9eUAp8pSF8VnRTP3xnvesZW2xOQ-xsNqO47m55DA.1e65e7e4eaaa9cda89cd.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/1pO9eUAp8pSF8VnRTP3xnvesZW2xOQ-xsNqO47m55DA.woff
// module id = 779
// module chunks = 1